import React from 'react';
import { useSelector } from 'react-redux';
import { getViewedItems2 } from '@src/containers/SpacesListing/selectors/getViewedItems';
import useFavourites from '@src/containers/Session/hooks/useFavourites';

import Recent from '..';

const RecentCDefault = (props) => {
	const places = useSelector(getViewedItems2);

	const { addSpaceToFavour, removeSpaceFromFavour } = useFavourites();

	const handleClickLike = React.useCallback(
		(isLiked, id) => {
			if (!isLiked) {
				addSpaceToFavour({ id });
			} else {
				removeSpaceFromFavour({ id });
			}
		},
		[addSpaceToFavour, removeSpaceFromFavour],
	);

	return <Recent places={places} onClickLike={handleClickLike} {...props} />;
};

export default RecentCDefault;
